import type { AppLocale } from '@/urls'

export const nn = {
    _prefix: '/nn',
    _locale: 'nn' as AppLocale,

    breadcrumbs: {
        mineArbeidsforhold: 'Mine arbeidsforhold',
        arbeidssted: 'Arbeidsstad',
        arbeidsforhold: 'Arbeidsforhold',
    },

    filter: {
        alle: 'Alle',
        aktive: 'Aktive',
        avsluttede: 'Avsluttede',
        fremtidige: 'Framtidige',
        ikkeValgt: 'Ikkje valt',
        ingenTreff: 'Ingen treff',
        soekEtterNavn: 'Søk etter namn',
        periode: 'Status',
        viserAntall: 'Viser %s av %s arbeidsforhold',
        sorterEtter: 'Sorter etter',
        sorterNavn: 'Namn (A–Å)',
        sorterStartdato: 'Startdato (nyaste først)',
        sorterSluttdato: 'Sluttdato (nyaste først)',
        sorterStillingsprosent: 'Stillingsprosent (høgast først)',
        sorterYrke: 'Yrke (A–Å)',
    },

    term: {
        arbeidstaker: 'Arbeidstakar',
        arbeidssted: 'Arbeidsstad',
        rapporteringsordning: 'Rapporteringsordning',
        arbeidsforholdstatus: 'Arbeidsforholdstatus',
        arbeidsforholdtype: 'Arbeidsforholdtype',
        foedselsnummer: 'Fødselsnummer',
        navn: 'Namn',
        organisasjonsnummer: 'Organisasjonsnummer',
        organisasjonsnavn: 'Organisasjonsnamn',
        stillingsprosent: 'Stillingsprosent',
        startdato: 'Startdato',
        sluttdato: 'Sluttdato',
        yrke: 'Yrke',
        arbeidsforhold: 'Arbeidsforhold',
    },

    detaljer: {
        arbeidstaker: 'Offentleg ident',
        ansettelsesperiode: 'Tilsetjingsperiode',
        hovedenhet: 'Hovudenhet',
        underenhet: 'Undereining',
        opplysningspliktig: 'Opplysningspliktig',
        organisasjonsnummer: 'Organisasjonsnummer %s',
        yrke: 'Yrke',
        yrkeskode: 'Yrkeskode',
        arbeidsforholdstype: 'Arbeidsforholdtype',
        arbeidsforholdId: 'Arbeidsforhold ID',
        arbeidstidsordning: 'Arbeidstidsordning',
        ansettelsesform: 'Tilsettingsform',
        avtaltStillingsprosent: 'Stillingsprosent',
        sisteStillingsprosentEndring: 'Endra stillingsprosent',
        sisteLonnsendring: 'Siste lønsendring',
        antallTimerPrUke: 'Timar per veke',
        sistBekreftet: 'Sist stadfesta av opplysningspliktig',
        sluttaarsak: 'Sluttårsak',
        sluttaarsakMedVerdi: '(Sluttårsak: %s)',
        fartsomraade: 'Fartsområde',
        skipsregister: 'Skipsregister',
        fartoeystype: 'Fartøystype',
        omArbeidsforholdet: 'Om arbeidsforholdet',
        opprettet: 'Oppretta',
        sistEndret: 'Sist endra',
        visEndringer: 'Vis endringar i arbeidsforholdet',
        antallEndringer: '%s endringar',
        enEndring: '1 endring',
        visAlleEndringer: 'Vis alle %s endringar',
        omRapporteringen: 'Om rapporteringa',
        viserForDato: 'Viser arbeidsforholdet slik det såg ut %s',
        tilbakestillDato: 'Tilbakestill til gjeldande dato',
        mangler: 'manglar',
    },

    tabs: {
        arbeidiutlandet: 'Arbeid i utlandet',
        historikk: 'Historikk',
        permisjonpermittering: 'Permisjon/Permittering',
        timerfortimelonnet: 'Timar for timeløna',
    },

    loading: {
        laster: 'Lastar...',
        henterArbeidsforhold: 'Hentar arbeidsforhold...',
        hentArbeidsforholddetaljer: 'Hentar arbeidsforholdsdetaljar...',
        hentPermisjoner: 'Hentar permisjonar',
        hentPermitteringer: 'Hentar permitteringar',
        hentUtenlandsopphold: 'Hentar utanlandsopphald',
        hentTimerMedTimeloenn: 'Hentar timar med timeløn',
    },

    permisjon: {
        permisjon: 'Permisjon',
        type: 'Permisjonstype',
        periode: 'Periode',
        prosent: 'Prosent',
        id: 'PermisjonsID',
        ingenTreff: 'Fann ingen permisjonar',
    },

    permittering: {
        permittering: 'Permittering',
        type: 'Permitteringstype',
        periode: 'Periode',
        prosent: 'Prosent',
        id: 'PermitteringsID',
        ingenTreff: 'Fann ingen permitteringar',
    },

    timerForTimeloennet: {
        timerForTimeloennet: 'Timar med timeløn',
        rapporteringsmaaned: 'Rapporteringsmånad',
        rapporteringsperiode: 'Periode',
        opptjeningsperiode: 'Oppteningsperiode',
        antallTimer: 'Antal timar',
        ingenTreff: 'Fann ingen timar med timeløn',
    },

    utenlandsopphold: {
        utenlandsopphold: 'Utanlandsopphald',
        rapporteringsmaaned: 'Rapporteringsmånad',
        rapporteringsperiode: 'Periode',
        land: 'Land',
        opptjeningsperiode: 'Oppteningsperiode',
        ingenTreff: 'Fann ingen utanlandsopphald',
    },

    historikk: {
        historikk: 'Historikk',
    },

    varsel: {
        ERKONK: 'Arbeidsgivaren har gått konkurs. Nav har sett same sluttdato som konkursopningsdato i Konkursregisteret.',
        EROPPH: 'Føretaket er opphøyrt i Einingsregisteret. Nav har sett same sluttdato som datoen føretaket opphøyrte.',
        ERVIRK: 'Føretaket er overdrege til ei anna juridisk eining. Nav har sett same sluttdato som datoen føretaket vart overdrege.',
        IBARBG: 'Arbeidsgivaren har ikkje stadfesta arbeidsforholdet. Nav har difor sett sluttdato til siste dato i den kalendermånaden arbeidsgivaren din sist stadfesta arbeidsforholdet.',
        IBKAOR: 'Sluttdato sett av Nav. Arbeidsforholdet er ikkje stadfesta gjennom a-ordninga. Sluttdato er sett til 31.12.2014',
    },

    knapp: {
        loggInn: 'Logg inn',
        lagre: 'Lagre',
        fortsett: 'Fortset',
        avbryt: 'Avbryt',
        nullstillValg: 'Nullstill val',
        lastNedPdf: 'Last ned PDF',
        lastNedExcel: 'Last ned Excel',
        skrivUtPdf: 'Skriv ut PDF',
        tilbake: 'Tilbake til oversikta',
        endreDataelementer: 'Endre dataelement',
        velgDato: 'Vel dato',
        velgMaaned: 'Vel månad',
        soek: 'Søk',
    },

    dataminimering: {
        velgDataelementer: 'Endre val av dataelement',
        beskrivelse:
            'Berre dei valde dataelementa vert henta og vist. Vel utelukkande dei dataelementa du har behov for i samsvar med behandlingsgrunnlaget ditt.',
        dataelementer: 'Dataelement',
        grupper: {
            ansettelse: 'Tilsetjing',
            arbeidstidOgLoenn: 'Arbeidstid og løn',
            historikkOgFravaer: 'Historikk og fråvær',
            maritimt: 'Maritimt',
        },
    },

    soek: {
        hvaVilDuSoekePaa: 'Kva vil du søkje på?',
        identLabel: 'Fødselsnummer, D-nummer eller organisasjonsnummer',
        skrivInnFnr: 'Skriv inn fnr/dnr',
        skrivInnOrgnr: 'Skriv inn orgnr/fnr/dnr',
        antallValgt: '%s valde',
        rapporteringsordning: {
            A_ORDNINGEN: 'A-ordninga',
            FOER_A_ORDNINGEN: 'Før a-ordninga',
        },
        arbeidsforholdstatus: {
            AKTIV: 'Aktiv',
            FREMTIDIG: 'Framtidig',
            AVSLUTTET: 'Avslutta',
        },
        arbeidsforholdtype: {
            ordinaertArbeidsforhold: 'Ordinært',
            maritimtArbeidsforhold: 'Maritimt',
            frilanserOppdragstakerHonorarPersonerMm: 'Frilansar m.m.',
            forenkletOppgjoersordning: 'Forenkla',
        },
    },

    feil: {
        pdf: 'Kunne ikkje lage PDF',
        excel: 'Kunne ikkje lage Excel',
        fantIkke: {
            navn: '(Namn manglar)',
            arbeidsforholdsdetaljer: 'Fann ikkje arbeidsforholdsdetaljar',
            permisjon: 'Fann ingen permisjonar',
            permittering: 'Fann ingen permitteringar',
            timerMedTimeloenn: 'Fann ingen timar med timeløn',
            utenlandsopphold: 'Fann ingen utanlandsopphald',
        },
        validering: {
            soek: {
                arbeidssted: 'Må vere 9 eller 11 siffer',
                arbeidstaker: 'Må vere 11 siffer',
                rapporteringsordning: 'Du må velje minst éi rapporteringsordning',
                arbeidsforholdstatus: 'Du må velje minst éin arbeidsforholdstatus',
                arbeidsforholdtype: 'Du må velje minst éin arbeidsforholdstype',
            },
        },
    },

    tabell: {
        viserAvTotalt: 'Viser %start - %slutt av totalt %total resultat',
        rader: 'Rader',
        visAlle: 'Vis alle (%s)',
        visFlere: 'Vis fleire (%s)',
        visMindre: 'Vis mindre',
        lukkAlleRader: 'Lukk alle rader',
        utvidAlleRader: 'Utvid alle rader',
        velgAlleRader: 'Vel alle rader',
    },

    excel: {
        info: 'Info',
        omDokumentet: 'Om dokumentet',
        generertAv: 'Generert av Arbeidsgivar- og arbeidstakarregisteret.',
        dato: 'Dato',
        antallArbeidsforhold: 'Antal arbeidsforhold',
        beskrivelse:
            'Denne Excel-fila inneheld ei oversikt over aktive og avslutta arbeidsforhold for den valde arbeidstakaren, slik dei er rapportert til Arbeidsgivar- og arbeidstakarregisteret etter 01.01.2015. \n Dersom det er feil i eit arbeidsforhold, skal du som arbeidsgivar endre dette gjennom a-meldinga.',
        aktiveArbeidsforhold: 'Aktive arbeidsforhold',
        avsluttedeArbeidsforhold: 'Avslutta arbeidsforhold',
        varsel: 'Varsel',
    },

    pdf: {
        footer1: 'Oversikta viser arbeidsforholda slik dei er rapportert til Arbeidsgivar- og arbeidstakarregisteret',
        footer2: 'Arbeids- og velferdsetaten // Utskrift frå %s',
        detaljerOmArbeidsforholdet: 'Detaljar om arbeidsforholdet',
        opplysningspliktig: 'Opplysningspliktig',
        timerPerUkeIFullStilling: 'Timar per veke i full stilling',
        foerstRapportert: 'Først rapportert av opplysningspliktig',
        sistRapportert: 'Sist rapportert av opplysningspliktig',
        arbeidsforholdSistEndret: 'Arbeidsforholdet vart sist endra',
        permisjoner: 'Permisjonar',
        ingenRegistrertePermisjoner: 'Ingen registrerte permisjonar.',
        permitteringer: 'Permitteringar',
        ingenRegistrertePermitteringer: 'Ingen registrerte permitteringar.',
        ingenRegistrertArbeidIUtlandet: 'Ikkje registrert arbeid i utlandet.',
        rapporteringsmaaned: 'Rapporteringsmånad',
        ingenRegistrerteTimerMedTimeloenn: 'Ingen registrerte timar med timeløn.',
        ingenRegistrerteEndringer: 'Ingen registrerte endringar.',
        endretTil: 'Endra til',
        av: 'av',
        periode: 'Periode',
        stillingsprosentendring: 'Stillingsprosentendring',
        antallTimerPerUke: 'Antal timar per veke',
        id: 'ID',
        utskrift: 'Utskrift',
        side: 'Side',
        timerPerUkeEnhet: 'timar per veke',
        lonnsendring: 'Lønsendring',
        typeArbeidsforhold: 'Type arbeidsforhold',
    },

    info: {
        hvisfeil1: 'Oversikta viser arbeidsforholda slik dei er rapportert av arbeidsgivar.',
        hvisfeil2: 'Dersom det er feil i eit arbeidsforhold, kan arbeidsgivaren endre gjennom a-meldinga.',
        ingenArbeidsforhold: 'Du har ingen registrerte arbeidsforhold.',
        opplysningIkkeValgt: 'Opplysning ikkje valt',
        ingenData: 'Ingen data',
    },

    landing: {
        loggInn: 'Logg inn',
        arbeidstaker: {
            heading: 'Innsyn i Aa-registeret for arbeidstakarar',
            body: 'Logg inn for å få oversikt over alle arbeidsforhold som arbeidsgivarane dine har rapportert inn på deg via A-meldinga.',
            linkArbeidsgiverTitle: 'Sjå tenester som arbeidsgivar',
            linkArbeidsgiverDescription: 'Gå til innlogga sider',
        },
        arbeidsgiver: {
            heading: 'Innsyn i Aa-registeret for arbeidsgivarar',
            body: 'Logg inn for å få oversikt over alle arbeidsforhold du som arbeidsgivar har rapportert inn via A-meldinga.',
            linkTilgangTitle: 'Korleis får eg tilgang?',
            linkTilgangDescription: 'Lær om roller og tilgangar i Altinn',
            linkPrivatTitle: 'Sjå tenester som privatperson',
            linkPrivatDescription: 'Gå til innlogga sider',
        },
        samarbeidspartner: {
            heading: 'Innsyn i Aa-registeret for samarbeidspartnarar',
            introBefore: 'Alle som har ',
            introLink: 'søkt',
            introAfter: ' om og fått innvilga tilgang, kan nytte tenesta.',
            introLine2: 'Her kan du gjere oppslag anten på arbeidsgivar (organisasjonsnummer) eller arbeidstakar (Fødselsnummer/D-nummer).',
            subheading: 'Nærare skildring av tenesta:',
            brukerveiledningBefore: 'Her finn du ',
            brukerveiledningLink: 'brukarrettleiing til tenesta',
            brukerveiledningAfter: '.',
            gratis: 'Tenesta er gratis å nytte.',
            sperretAdresse: 'Opplysningar om personar med sperra adresse etter folkeregisterlova §10-4 vert ikkje utlevert.',
            utloggetInaktivitet: 'Du blir logga ut etter inaktivitet i ????? timar.',
            dataminimering:
                'Dine val for dataminimering og filtrering vert lagra innanfor påloggjinga, men må gjerast på nytt ved neste påloggjing.',
            driftsvarslerBefore: 'Du kan følgje med på ',
            driftsvarslerLink: 'nyhende og driftsvarsel',
            driftsvarslerAfter: ' knytt til tenesta.',
            infoBoxTitle: 'Tildeling av tilgang skjer i Altinn',
            infoBoxLink: 'Les meir her',
        },
    },

    ingenTilgang: {
        arbeidsgiver: {
            heading: 'Innsyn i Aa-registeret for arbeidsgivarar',
            body: 'Her finn du oversikt over alle arbeidsforhold som er rapportert inn via A-meldinga.',
            ikkeTilgangTitle: 'Du har ikkje tilgang til tenesta',
            aarsakerIntro: 'Det kan vere fleire årsaker til at du ikkje har tilgang:',
            aarsak1: 'Du har ikkje fått delegert fullmakt til tenesta i Altinn av hovudadministratoren eller tilgangsstyraren i verksemda.',
            aarsak2: 'Du har ikkje ei rolle i einingsregisteret som gir tilgang til denne tenesta.',
            hvordanTilgangTitle: 'Korleis får eg tilgang?',
            hvordanTilgangBodyBefore:
                'For å få tilgang til innsynstenesta for arbeidsforhold innrapportert via a-meldinga treng du enkelttenesta «Innsyn i Arbeidsgivar- og arbeidstakarregisteret (Aa-registeret) for arbeidsgivarar» i ',
            hvordanTilgangBodyLink: 'Altinn',
            hvordanTilgangBodyAfter: '.',
            hvordanTilgangRollerIntro: 'Tilgang blir også gitt automatisk til personar med desse rollene i einingsregisteret:',
            hvordanTilgangRoller: [
                'dagleg leiar/administrerande direktør',
                'styreleiar',
                'innehavar av enkeltpersonføretak',
                'deltakar i ansvarleg selskap (ANS og DA)',
                'bestyrande reiar',
                'bustyrar i konkursbu (omfattar ikkje verksemda som har gått konkurs) og andre bu',
                'komplementar (berre fødselsnummer)',
                'norsk representant for utanlandsk eining',
            ],
            linkPrivatTitle: 'Sjå tenester som privatperson',
            linkPrivatDescription: 'Gå til innlogga sider',
            linkTilgangTitle: 'Korleis får eg tilgang?',
            linkTilgangDescription: 'Lær om roller og tilgangar i Altinn',
        },
        samarbeidspartner: {
            heading: 'Innsyn i Aa-registeret for samarbeidspartnarar',
            body: 'Her finn du oversikt over arbeidsforhold som er rapportert inn via A-meldinga.',
            ikkeTilgangTitle: 'Du har ikkje tilgang til tenesta',
            aarsakerIntro: 'Det kan vere fleire årsaker til at du ikkje har tilgang:',
            aarsak1: 'Du er ikkje delegert tilgang i Altinn av ein administrator.',
            aarsak2: 'Rollene og tilgangane dine i Altinn gir ikkje tilgang til denne tenesta.',
            linkTilgangTitle: 'Korleis får eg tilgang?',
            linkTilgangDescription: 'Lær om roller og tilgangar i Altinn',
        },
    },

    bruksvilkaar: {
        heading: 'Bruksvilkår',
        velkommen: 'Velkomen til web-oppslagsløysinga for Arbeidsgivar- og arbeidstakarregisteret (Aa-registeret).',
        forBenytte: 'For å nytte tenesta må du vere klar over følgjande:',
        taushetspliktLine1:
            'Alle opplysningane i Aa-registeret er underlagt lovbestemt teieplikt, jf. forskrift om Aa-registeret § 16. Du pliktar å ha gjort deg kjend med kva dette inneber før du nyttar tenesta. Ved å krysse av for at du har lese og forstått bruksvilkåra stadfestar du at du er kjend med teieplikta og at du forpliktar deg til å etterleve denne.',
        taushetspliktLine2Before:
            'Du finn meir informasjon om teieplikta og kva ho inneber i bruksvilkåra di verksemd har godkjent og forplikta seg til å etterleve i kapittel 10 ',
        taushetspliktLine2Link: 'her',
        taushetspliktLine2After: '.',
        taushetspliktLine3: 'Brot på teieplikta kan straffast med bøter eller med fengsel i inntil 1 år, sjå straffelova §209.',
        dataminimeringLine1:
            'Du er forplikta til å ikkje gjere oppslag på, eller hente ut, fleire dataelement frå Aa-registeret enn det som er naudsynt ut frå kva for formål som er innvilga, medrekna kva som er ditt tenstlege behov.',
        dataminimeringLine2:
            'Arbeidsgivaren din har i samband med søknaden om tilgang til Aa-registeret oppgitt kva for dataelement som er naudsynte å gjere oppslag på ut frå kva som er formålet for tilgangen for di verksemd. Dersom du opplever at det er behov for å nytte fleire dataelement enn desse, så må arbeidsgivaren din søkje om å få utvida tilgangen tilsvarande. Vi må ha godkjent denne søknaden før det vert gjort lovleg oppslag. Dersom du ikkje veit kva for dataelement arbeidsgivaren din har oppgitt som naudsynte, ta kontakt med arbeidsgivaren din før du nyttar deg av tenesta.',
        uforenelig: 'Opplysningane kan ikkje nyttast til formål som er uforeinlege med det opphavlege formålet (uberettiga oppslag).',
        logging:
            'Alle oppslag vert logga på system- og personnivå, og kan sporast i ettertid. Den registrerte har som utgangspunkt rett til å få innsyn i slike loggar om dei ber om dette. NAV har rett til å nytte desse loggane som grunnlag dersom det vert mistenkt uberettiga oppslag.',
        avslutningBefore:
            'Vi rår deg til å setje deg inn i dei øvrige bruksvilkåra som di verksemd har godkjent og forplikta seg til å etterleve for å kunne nytte tenesta. Her finn du ',
        avslutningLink: 'generelle bruksvilkår',
        avslutningAfter: ' for bruk av Aa-registeret.',
        checkboxLabel: 'Eg har lese og forstått bruksvilkåra',
        godtaButton: 'Godta vilkår',
    },

    arbeidsgiverHovedenhet: {
        underenheterInfo: 'Oversikta viser undereiningar der hovudeininga har eller har hatt rapporterte arbeidsforhold.',
        undetenheterInfo2:
            'Det kan finnast fleire arbeidsstader (undereiningar) på denne hovudeininga som ikkje vert viste i lista fordi det aldri har vore rapportert tilsette.',
        clearUnderenhetButtonLabel: 'Tøm søkjefelt',
        sokPlaceholder: 'Søk på undereining...',
        sokLabel: 'Søk på undereining',
        ingenUnderenheter: 'Verksemda har ingen undereiningar med rapporterte arbeidsforhold',
        fantIkkeUnderenhet: 'Fann ingen undereiningar som samsvarer med søket ditt',
        lesMer: 'Om oversikta',
        merkelapp: 'Hovudeining',
        sorterArbeidsforhold: 'Talet på arbeidsforhold (flest først)',
        viserAntall: 'Viser %s av %s undereiningar',
        visFlere: 'Vis fleire undereiningar',
    },
    underenhetTableRow: {
        copyIdent: 'Kopier organisasjonsnummer for ',
        aktiveArbForhold: 'aktive arbeidsforhold',
        inaktiveArbForhold: 'inaktive arbeidsforhold',
    },

    kopier: {
        fnrMedNavn: 'Kopier fødselsnummer for %s',
        orgnrMedNavn: 'Kopier organisasjonsnummer for %s',
        fnr: 'Kopier fødselsnummer',
        orgnr: 'Kopier organisasjonsnummer',
    },

    hjelpetekst: {
        om: 'Om %s?',
        arbeidssted: 'Undereininga arbeidstakaren er tilsett i. For ein personleg arbeidsgivar er arbeidsstaden personen sjølv.',
        opplysningspliktig:
            'Den som har plikt til å rapportere opplysningar om arbeidsforholdet, i praksis gjennom a-meldinga. For ein organisasjon er dette hovudeininga, for ein personleg arbeidsgivar personen sjølv.',
        startdato: 'Datoen arbeidsforholdet startar ifølgje arbeidsavtala. Startdatoen treng ikkje vere den same som første dag på jobb.',
        sluttdato:
            'Datoen arbeidsforholdet opphøyrer. Sluttdatoen er ikkje alltid den siste dagen arbeidstakaren møter på jobb, fordi arbeidsforholdet ikkje er formelt avslutta før til dømes turnusperioden er over eller avspaseringsdagar er tekne ut.',
        sluttaarsak: 'Årsaka til at arbeidsforholdet blei avslutta.',
        yrke: 'Kombinasjonen av yrkestittel og yrkeskode. Yrkeskoden er ein sjusifra kode i yrkeskatalogen hos Statistisk sentralbyrå, og blir bestemt av arbeidsoppgåvene arbeidstakaren faktisk utfører – ikkje av utdanningsnivå eller stillingstype.',
        avtaltStillingsprosent:
            'Prosentdelen den avtalte arbeidstida til arbeidstakaren utgjer av det som er heiltid for tilsvarande stilling.',
        sisteStillingsprosentEndring: 'Datoen stillingsprosenten sist blei endra.',
        antallTimerPrUke:
            'Talet på timar per veke som utgjer ei 100 % stilling. Blir mellom anna brukt til å rekne ut stillingsprosent for arbeidstakarar som jobbar deltid.',
        ansettelsesform: 'Om arbeidstakaren er fast eller mellombels tilsett.',
        arbeidstidsordning: 'Avtale om når på døgnet arbeidet skal skje, og eventuelle variasjonar i denne over ein periode.',
        sisteLonnsendring: 'Datoen arbeidstakaren sist fekk endra løn.',
        fartsomraade: 'Det avgrensa området det maritime arbeidsforholdet finn stad i, anten innanriksfart eller utanriksfart.',
        skipsregister:
            'Registeret det maritime fartøyet er registrert i: NOR (Norsk ordinært skipsregister), NIS (Norsk internasjonalt skipsregister) eller UTLA (utanlandsk registrert fartøy).',
        fartoeystype: 'Typen sjøgåande fartøy det maritime arbeidsforholdet finn stad på, til dømes turistskip eller boreplattform.',
        opprettet: 'Tidspunktet arbeidsforholdet blei oppretta i Aa-registeret.',
        sistEndret: 'Tidspunktet Nav sist mottok og utførte ei endring i eitt eller fleire datafelt i arbeidsforholdet.',
        sistBekreftet:
            'Tidspunktet den sist mottekne a-meldinga om arbeidsforholdet blei behandla. Den opplysningspliktige stadfestar arbeidsforholdet ved å sende a-melding.',
        rapporteringsordning:
            'Viser om arbeidsforholdet er rapportert gjennom a-ordninga, som vart innført 01.01.2015, eller gjennom den tidlegare rapporteringsordninga.',
        arbeidsforholdId:
            'Identifikator som skil dei enkelte arbeidsforholda frå kvarandre når arbeidstakaren eller frilansaren har fleire arbeidsforhold i same undereining.',
        permisjon: {
            periode: 'Perioden arbeidstakaren er i permisjon, angitt med første og siste permisjonsdag.',
            type: 'Kort, førehandsdefinert tekst som seier noko om grunnlaget for permisjonen.',
            prosent: 'Kor mange prosent permisjonen utgjer av den avtalte stillingsprosenten til arbeidstakaren.',
            id: 'Identifikator som er unik for permisjonen innanfor arbeidsforholdet. Arbeidsgivaren må bruke ein ny identifikator ved ein seinare permisjon, eller ved permisjonar som overlappar i tid.',
        },
        permittering: {
            periode:
                'Perioden arbeidsgivaren har permittert arbeidstakaren. Perioden startar når permitteringa er sett i verk, som regel første lønspliktdag.',
            type: 'Kort, førehandsdefinert tekst som seier noko om grunnlaget for permitteringa.',
            prosent: 'Kor mange prosent permitteringa utgjer av den avtalte stillingsprosenten til arbeidstakaren.',
            id: 'Identifikator som er unik for permitteringa innanfor arbeidsforholdet. Arbeidsgivaren må bruke ein ny identifikator dersom arbeidstakaren blir permittert på nytt seinare.',
        },
        timerForTimeloennet: {
            rapporteringsmaaned: 'Månaden opplysninga er rapportert for. Han er ikkje nødvendigvis den same som oppteningsperioden.',
            opptjeningsperiode: 'Perioden timane blei arbeidde i. Blir berre oppgitt når arbeidsgivaren har rapportert han.',
            antallTimer:
                'Talet på arbeidstimar som ligg til grunn for utbetaling av løn til ein tilsett med timeløn. Timar opptente som overtid inngår ikkje i Aa-registeret.',
        },
        utenlandsopphold: {
            rapporteringsmaaned: 'Månaden opplysninga er rapportert for. Han er ikkje nødvendigvis den same som oppteningsperioden.',
            opptjeningsperiode: 'Perioden inntekta blei opptent i. Blir berre oppgitt når arbeidsgivaren har rapportert han.',
            land: 'Landet arbeidstakaren har opptent inntekt i.',
        },
    },

    footer: {
        informasjon: 'Informasjon om tenesta',
        driftsvarsler: 'Nyheiter og driftsvarsel',
        driftsvarslerBeskrivelse: 'Endringar i tenesta og varsel om planlagd eller uventa nedetid.',
        brukerstoette: 'Brukarstøtte',
        brukerstoetteHeading: 'Faglege, funksjonelle eller tekniske spørsmål til Aa-registeret',
        faqBefore: 'Før du sender faglege, funksjonelle eller tekniske spørsmål i brukarstøttetenesta, må du sjekke vanlege ',
        faqLink: 'spørsmål og svar',
        faqAfter: '.',
        dokumentasjonBefore: 'Sjå òg ',
        dokumentasjonLink: 'fagleg og teknisk skildring av tenestene',
        dokumentasjonAfter: ' (Github).',
        naarKontakte: 'Dersom du ikkje finn svar på spørsmåla dine, kan du kontakte brukarstøtte når du:',
        kontaktPunkt1: 'Har faglege, funksjonelle og tekniske spørsmål om Aa-registeret og innsynsløysinga',
        kontaktPunkt2: 'Har tips om uriktige eller manglande opplysningar i registeret',
        kontaktPunkt3: 'Vil varsle om feil eller tryggingsbrot i innsynstenesta',
        kontaktPunkt4: 'Vil melde frå om endringsønske',
        tilgangMerknad: 'NB! Spørsmål om å søkje tilgang til Aa-registeret gjeld ikkje for arbeidsgivarar og arbeidstakarar.',
        merInformasjonLink: 'Her finn du meir informasjon om Arbeidsgivar- og arbeidstakarregisteret',
        arbeidstaker: {
            regionLabel: 'Hjelp og informasjon',
            informasjonBeskrivelse: 'Kva oversikta viser, kven som eig Aa-registeret og kva Nav bruker opplysningane til.',
            brukerstoetteBeskrivelse: 'Spørsmål og svar, og kva du gjer dersom det er feil i opplysningane om arbeidsforholda dine.',
            informasjonAvsnitt1:
                'Oversikta viser alle arbeidsforhold rapporterte etter 01.01.2015, slik arbeidsgivaren har rapportert dei. Dersom det er feil i eit arbeidsforhold, kan arbeidsgivaren endre det gjennom a-meldinga.',
            informasjonAvsnitt2:
                'Nav treng informasjon om arbeidsforholda dine for å kunne vurdere behovet ditt for oppfølging og tenester frå Nav, og for å rekne ut kor mykje du kan få utbetalt i til dømes sjukepengar, dagpengar og foreldrepengar. Andre offentlege etatar har òg tilgang til opplysningar frå Arbeidsgivar- og arbeidstakarregisteret.',
            informasjonAvsnitt3:
                'Det er Arbeids- og velferdsetaten som eig og forvaltar Arbeidsgivar- og arbeidstakarregisteret (Aa-registeret).',
            feilHeading: 'Feil i opplysningane om arbeidsforholda dine?',
            feilAvsnitt1:
                'Dersom det er feil i opplysningane om arbeidsforholda dine i Arbeidsgivar- og arbeidstakarregisteret, må du kontakte arbeidsgivaren, som kan endre dei gjennom a-meldinga.',
            feilAvsnitt2: 'Dersom arbeidsgivaren ikkje kan hjelpe deg, kan du kontakte brukarstøtta til Nav for Aa-registeret.',
        },
        arbeidsgiver: {
            regionLabel: 'Hjelp og informasjon',
            informasjonBeskrivelse: 'Kva oversikta viser, korleis du rettar feil gjennom a-meldinga og kva Nav bruker opplysningane til.',
            brukerstoetteBeskrivelse: 'Har du spørsmål om Aa-registeret, a-meldinga eller pålogging til tenesta?',
            informasjonAvsnitt1:
                'Oversikta viser alle arbeidsforhold rapporterte etter 01.01.2015 for vald verksemd. Dersom du finn feil i oversikta, skal du som arbeidsgivar endre dette gjennom a-meldinga.',
            aMeldingBefore: 'Sjå ',
            aMeldingLink: 'rettleiinga til Skatteetaten om a-meldinga',
            aMeldingAfter: '.',
            informasjonAvsnitt2:
                'Nav treng informasjon om arbeidsforholda for å kunne vurdere behovet for oppfølging og tenester frå Nav, og for å rekne ut kor mykje arbeidstakarane dine kan få utbetalt i til dømes sjukepengar, dagpengar og foreldrepengar. Andre offentlege etatar har òg tilgang til opplysningar frå Arbeidsgivar- og arbeidstakarregisteret.',
            informasjonAvsnitt3:
                'Det er Arbeids- og velferdsetaten som eig og forvaltar Arbeidsgivar- og arbeidstakarregisteret (Aa-registeret).',
            brukerstoette: {
                altinnHeading: 'Har du spørsmål knytte til Altinn-rettar for tenesta eller pålogging via Altinn',
                altinnBefore:
                    'Dersom du har spørsmål knytte til delegering av altinn-retten «Innsyn i Arbeidsgivar- og arbeidstakarregisteret (Aa-registeret) for arbeidsgivarar» eller pålogging, kan du ',
                altinnLink: 'få hjelp hos Altinn',
                altinnAfter: ' (',
                altinnKildeLink: 'Altinn.no',
                altinnKildeAfter: ').',
                aMeldingHeading: 'Korleis rapportere arbeidsforhold til Aa-registeret via a-meldinga?',
                aMeldingBefore:
                    'Har du spørsmål om korleis du rapporterer arbeidsforhold eller gjer korrigeringar, finn du nærmare informasjon i ',
                aMeldingVeiledningLink: 'rettleiinga til a-meldinga',
                aMeldingMellom: ', eller du kan ',
                aMeldingKontaktLink: 'kontakte a-ordninga',
                aMeldingAfter: ' (',
                aMeldingKildeLink: 'Skatteetaten.no',
                aMeldingKildeAfter: ').',
                andreHeading: 'Andre spørsmål om Aa-registeret',
                andreBefore:
                    'Du finn nærmare informasjon om kva Aa-registeret er, meldeplikta til registeret, kva informasjon som finst i registeret, og kven som kan ta imot opplysningar frå registeret på denne sida ',
                andreLink: 'om Aa-registeret på nav.no',
                andreMellom: ' eller du kan ',
                andreKontaktLink: 'kontakte Nav registerforvaltning',
                andreAfter: '.',
            },
        },
        samarbeidspartner: {
            regionLabel: 'Hjelp og kontakt',
            kontaktKnapp: 'Kontakt Aa-registeret',
            brukerveiledning: 'Brukarrettleiing (pdf)',
            brukerveiledningBeskrivelse: 'Steg for steg gjennom web-oppslag i Aa-registeret.',
            tips: 'Tips om manglande eller uriktige opplysningar',
            tipsBeskrivelse: 'Kva du bør tipse om, kva eit godt tips inneheld og korleis du sender det inn.',
            brukerstoetteLenke: 'Fagleg, funksjonell eller teknisk brukarstøtte',
            brukerstoetteBeskrivelse: 'Spørsmål og svar, teknisk skildring av tenestene og når du bør kontakte brukarstøtte.',
            kontaktPunkt1: 'Har tips om uriktige eller manglande opplysningar i registeret',
            kontaktPunkt2: 'Har faglege, funksjonelle og tekniske spørsmål om Aa-registeret og distribusjonsløysingane',
            kontaktPunkt3: 'Vil melde frå om endringsønske',
            kontaktPunkt4: 'Vil varsle om feil eller tryggingsbrot i innsynstenesta',
            kontaktPunkt5: 'Har spørsmål om å søkje tilgang til Aa-registeret',
            klikkBefore: 'Klikk på ',
            klikkLink: '«Kontakt Aa-registeret»',
            klikkAfter: ' og oppgi kategorien du meiner passar best. Det er ikkje kritisk om du vel feil kategori.',
            beskrivHenvendelse:
                'Skildre førespurnaden best mogleg. Du kan òg laste opp vedlegg dersom det er viktig for å belyse førespurnaden.',
            tipsHeading: 'Tips om uriktige eller manglande opplysningar i registeret',
            tipsIntro:
                'Dersom du ser uriktige eller manglande opplysningar i registeret, ønskjer vi at du tipsar oss om dette gjennom brukarstøtteløysinga til Nav.',
            tipsEksemplerIntro: 'Døme på kva det kan tipsast om:',
            tipsEksempel1: 'Feil eller manglande start- og/eller sluttdato',
            tipsEksempel2: 'Arbeidsforhold er ikkje rapportert, men skulle vore det',
            tipsEksempel3: 'Mistanke om at det ligg føre fiktive arbeidsforhold',
            tipsEksempel4: 'Manglande eller feil rapportering av permisjon/permittering',
            tipsEksempel5: 'Feil stillingsprosent',
            tipsEksempel6: 'Manglande rapportering av inntekt, men arbeidsforholdet er rapportert',
            tipsInnholdIntro: 'Eit godt tips om moglege uriktige eller manglande opplysningar i Aa-registeret må innehalde:',
            tipsInnhold1: 'Namn og fødsels- og personnummer til den det gjeld',
            tipsInnhold2: 'Kven som er arbeidsgivar (organisasjonsnummer)',
            tipsInnhold3: 'Dato for når forholdet vart avdekt/oppdaga',
            tipsInnhold4: 'Bakgrunnen for tipset',
            tipsInnhold5: 'All dokumentasjon/informasjon som støttar grunnlaget for tipset, og som de har lov til å dele',
            tipsInnhold6: 'Informasjon om det ligg føre arbeidsavtale eller timelister',
            tipsInnhold7: 'Anna informasjon som tilseier at vedkomande arbeider der',
            tipsInnhold8: 'Vurdering av kor sannsynleg det er at det ligg føre eit reelt arbeidsforhold',
            tipsInnhold9: 'Har de gitt informasjon til arbeidsgivaren? Kva?',
            tipsKlikk:
                'Klikk på «Kontakt Aa-registeret» og vel kategorien «Tips om uriktige eller manglande opplysningar i registeret» i emnefeltet, og oppgi informasjon og eventuelle vedlegg.',
            tipsPostBefore: 'Dersom du ikkje kan bruke brukarstøtteløysinga, kan du sende tips via: ',
            tipsPostLink: 'Send i posten',
            tipsPostAfter:
                '. Dette krev ikkje innlogging. I neste steg vel du «Fleire personar samtidig eller tiltaksbedrifter, kursarrangørar og andre verksemder» under kven innsendinga gjeld, og Nav registerforvaltning som mottakande eining.',
        },
    },
}
